import { useState } from 'react';
import { Button, Modal, TextField } from '@mui/material';
import PhotoIcon from '@mui/icons-material/Photo';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';
// @ts-ignore
import 'react-html5-camera-photo/build/css/index.css';

import { CloseModalButton } from '@components/CloseModalButton';
// @ts-ignore
import './styles.css';
import { useTranslation } from 'react-i18next';
import { usePhotoShare } from '@hooks/usePhotoShare';
import { RootState } from '@state-mgmt/store';
import { useSelector } from 'react-redux';

export interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (image: string, description: string) => void;
}

const CameraModal = ({ open, onClose, onConfirm }: Props) => {
  const { t } = useTranslation();

  const [dataUri, setDataUri] = useState<string | undefined>();
  const [description, setDescription] = useState('');

  const handleCameraError = (error: any) => {
    alert(`handleCameraError: ${error}`);
  };

  const themeMode = useSelector((state: RootState) => state.app.themeMode);

  const { savePhoto } = usePhotoShare({ url: dataUri });

  const handleClose = () => {
    setDataUri(undefined);
    setDescription('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      {!dataUri ? (
        <>
          <CloseModalButton onClick={handleClose} />

          <Camera
            onCameraError={handleCameraError}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            sizeFactor={0.75}
            onTakePhoto={dataUri => setDataUri(dataUri)}
            isDisplayStartCameraError={false}
          />
        </>
      ) : (
        <div className="demo-image-preview">
          <CloseModalButton onClick={handleClose} />

          <div className="image-container">
            <img src={dataUri} alt="something" />
          </div>

          <div className="actions-description">
            <TextField
              label="Photo description"
              value={description}
              onChange={e => setDescription(e.target.value)}
              multiline
              rows={3}
              fullWidth
              inputProps={{
                maxLength: 500
              }}
              helperText={`${description.length}/500`}
              sx={
                themeMode === 'light'
                  ? {
                      '& .MuiInputBase-input': {
                        color: 'white'
                      },
                      '& .MuiInputLabel-root:not(.Mui-focused)': {
                        color: 'white'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white'
                      },
                      '& .MuiOutlinedInput-root:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white'
                      },
                      '& .MuiFormHelperText-root': {
                        color: 'white'
                      }
                    }
                  : {}
              }
            />
          </div>

          <div className="actions">
            <Button variant="outlined" onClick={() => setDataUri(undefined)} sx={{ textTransform: 'uppercase' }}>
              {t('general.cancel')}
            </Button>

            <Button variant="outlined" onClick={savePhoto} sx={{ textTransform: 'uppercase' }} startIcon={<PhotoIcon />}>
              {t('general.save')}
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                onConfirm(dataUri, description);
                setDataUri(undefined);
                setDescription('');
              }}
              sx={{ textTransform: 'uppercase' }}
            >
              {t('general.confirm')}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CameraModal;
